/**
 * draftSurfaceStyles — the shared "document paper" surface look used by both
 * DocumentDraftModal and ResolutionModal.
 *
 * These were duplicated inline in each modal; hoisting them here keeps the two
 * drafting surfaces from drifting apart. The objects are consumed as plain
 * inline `style` values, so the rendered output is identical to the old inline
 * literals — this is a DRY refactor, not a visual change.
 */

// The soft radial "desk" backdrop the paper sits on.
export const DOC_STAGE_STYLE = {
  background: 'radial-gradient(circle at 50% 30%, #f6f3eb 0%, #e2ded5 100%)',
  padding: '36px 20px',
  minHeight: '820px',
};

// The A4-ish white page: subtle rounding, hairline border, layered drop shadow.
export const DOC_PAPER_STYLE = {
  maxWidth: '820px',
  borderRadius: '6px',
  border: '1px solid rgba(8, 17, 31, 0.06)',
  boxShadow:
    '0 1px 3px rgba(0,0,0,0.05), 0 10px 30px -5px rgba(8, 17, 31, 0.08), 0 25px 50px -12px rgba(8, 17, 31, 0.12)',
  overflow: 'hidden',
};

/**
 * The contentEditable document body. The teal focus-ring (border + box-shadow)
 * lights up only while the page is unlocked for editing.
 *
 * Per-modal extras (`backgroundColor`, `pointerEvents`) are spread in by the
 * caller so this stays the single source for the shared typography + focus ring.
 */
export const docEditorStyle = ({ editable, canEdit }) => ({
  padding: '54px 64px',
  fontFamily: "'Times New Roman', Times, serif",
  fontSize: '13pt',
  lineHeight: 1.8,
  color: '#0d1b2a',
  minHeight: '840px',
  outline: 'none',
  border: editable && canEdit ? '2px solid #145f5f' : '2px solid transparent',
  boxShadow: editable && canEdit ? '0 0 0 4px rgba(20, 95, 95, 0.12)' : 'none',
  transition: 'border-color 0.2s, box-shadow 0.2s',
  opacity: canEdit ? 1 : 0.8,
});
